export const CloseAccountType = {
  USER_INITIATED_WITH_FUNDS: "USER_INITIATED_WITH_FUNDS",
  USER_INITIATED_WITHOUT_FUNDS: "USER_INITIATED_WITHOUT_FUNDS",
  USER_INITIATED_WITH_FUNDS_BELOW_FEE_AMOUNT:
    "USER_INITIATED_WITH_FUNDS_BELOW_FEE_AMOUNT",
  SUPPORT_INITIATED: "SUPPORT_INITIATED",
};
